import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { filter, Subject, takeUntil, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AccessRequestService } from '../../datasource/services/access-request.service';
import { LoginService } from '../../datasource/services/login.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { BrowserAuthError, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'jafar-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent implements OnInit, OnDestroy {
  // Local Class Variables
  activeAccount : any = null
  errorMessage: boolean = false;
  feedbackmessage : string = ""
  logoUrl = environment.generic.logoUrlLight
  welcomeMessage: string = environment.welcomemessage

  private readonly _destroying$ = new Subject<void>();

  // Service Injections
  authService = inject(MsalService)
  loginService = inject(LoginService)
  msalBroadcastService = inject(MsalBroadcastService)
  router = inject(Router)

  constructor(
    public accessRequest: AccessRequestService,
  ) {}

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe();

    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      tap((result: InteractionStatus) => console.log("Interaction status:", result)),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      console.log("Subscribe Inprogress")
      this.checkAndSetActiveAccount();
    })
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    this.activeAccount = this.authService.instance.getActiveAccount();

    if(this.activeAccount){
      this.router.navigate(['/home'])
    }

    if (!this.activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      this.router.navigate(['/home'])
    }
  }

  ngOnDestroy() :void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  homePageLogin(){
     this.loginService.login()
  }

  homePageLogout(){
    this.loginService.logout()
  }


}
